<template>
  <a-modal v-model="visible" :footer="null" :width="330"  class="updatelog" :afterClose="close" centered>
    <div class="updatelogbody">
      <div></div>
      <div>
          <div> <div class="title">{{version_id||''}}</div> <div class="end">{{ctime||''}}</div></div>
          <div v-html="update_content||''">
          </div>
      </div>
      <div>
        <a-button  type='primary' style="width:80%;"  size="large" id="updatelog-btn" @click="know">我知道了</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true,
      error: "",
      value: "",
      ctime:'',
      id:'',
      update_content:'',
      version_id:''
    };
  },
  props: {
    close: Function,
    version:{
      required: true,
      type: Object
    }
  },
  created(){
    let {id='',update_content='',ctime='',version_id=''}= this.version;
    this.id=id;this.update_content=update_content;this.ctime=ctime;this.version_id=version_id;
  },
  methods:{
    know(){
      this.$setStore('version_id',this.id);
      this.visible=false;
    }
  }
};
</script>
<style lang="scss">
.updatelog {
  .ant-modal-content{
    border-radius: 10px;
  }
  .ant-modal-close-x{
    display:inline-block;
    position: relative;
    left: 14px;
    top: -14px;
    font-size: 20px;
  }
  .ant-modal-body {
    padding: 0;
    text-align: center;
    .updatelogbody {
      font-size: 12px;
      width: 330px;
      min-height: 200px;
      color: #999;
      &>div:first-child{
        background-image: url("~@/assets/img/updatelog.jpg");
        background-repeat: no-repeat;
        border-radius: 10px;
        width: 100%;
        height: 120px;
      }
      &>div:nth-child(2){
        font-size: 15px;
        white-space: pre-line;
        text-align:left;
        margin: 2px 30px 20px;
        &>div:first-child{
          &>div{
            width: 50%;
            display: inline-block;
          }
          .title{
            font-weight: bold;
            color: black;
          }
          .title::before{
            content: '';
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 5px;
            border: 5px solid #1890ff;
            position: relative;
            top: 17px;
            left: -17px;
          }
          .end{
            text-align: right;
            font-size: 12px;
          }
        }
        &>div:last-child{
          margin-top:10px;
          font-size:12px;
          line-height: 25px;
        }
      }
      &>div:last-child{
        padding-bottom: 30px;
        &>.ant-btn-lg{
           border-radius: 50px ;
        }
      }
    }
  }
}
</style>